module.exports = __webpack_public_path__ + "img/landing29.8dd88216.jpg";